$(document).ready(() => {
  if ($('.js-manage-namespace').length) require('./app')
})
